(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('ConsultationController', ConsultationController);

  /* ngInject */
  function ConsultationController($state, $stateParams, config, consultationService, sessionService) {
    const vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.messagePriority = $stateParams.messagePriority || null;
    vm.messageStatus = $stateParams.messageStatus || null;
    vm.messageType = $stateParams.messageType || null;
    vm.messageVisibility = $stateParams.messageVisibility || null;
    vm.query = $stateParams.query || null;
    vm.fromDate = $stateParams.fromDate || null;
    vm.toDate = $stateParams.toDate || null;
    vm.activate = activate;
    vm.filterChange = filterChange;
    vm.loading = false;
    vm.getMessageThreads = getMessageThreads;
    vm.messageThreads = [];
    vm.orderBy = orderBy;
    vm.pageChange = pageChange;
    vm.sort = $stateParams.sort || 'updated_at';
    vm.sortDirection = $stateParams.sortDirection || 'desc';
    vm.totalCount = 9999;
    vm.consultationCounts = {};

    vm.activate();

    function activate() {
      vm.getMessageThreads();
      getConsultationCounts();
    }

    function filterChange() {
      $state.go(
        'application.compliance_services.consultation',
        {
          currentPage: vm.currentPage,
          query: vm.query,
          fromDate: vm.fromDate,
          toDate: vm.toDate,
          messagePriority: vm.messagePriority,
          messageStatus: vm.messageStatus,
          messageType: vm.messageType,
          messageVisibility: vm.messageVisibility,
          sort: vm.sort,
          sortDirection: vm.sortDirection
        },
        { reload: true, inherit: false, notify: true }
      );
    }

    function getMessageThreads() {
      vm.loading = true;
      
      consultationService(sessionService.getAuthToken()).query({
        page: vm.currentPage,
        status: vm.messageStatus,
        message_type: vm.messageType,
        visibility: vm.messageVisibility,
        urgent: vm.messagePriority,
        query: vm.query,
        from_date: vm.fromDate,
        to_date: vm.toDate,
        sort: vm.sort,
        sort_direction: vm.sortDirection
      }, function(response) {
        vm.loading = false;
        vm.messageThreads = response.message_threads;
        vm.totalCount = response.meta.total_count;
      });
    }

    function orderBy(sort) {
      if (sort == vm.sort) {
        if (vm.sortDirection == 'desc') {
          vm.sortDirection = 'asc';
        } else {
          vm.sortDirection = 'desc';
        }
      } else {
        vm.sortDirection = 'asc';
        vm.sort = sort;
      }

      getMessageThreads();
    }

    function getConsultationCounts() {
      consultationService(sessionService.getAuthToken()).counts({}, function(response) {
        vm.consultationCounts = response;
      });
    }



    function pageChange(newPageNumber, _oldPageNumber) {
      vm.currentPage = newPageNumber;
      vm.filterChange();
    }
  }
})();